import React from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'
import noImage from '@assets/images/placeholder/article-placeholder.jpg'
import { convertDt24h, dateCheck, getArticleImg } from '@shared-submodule/utils'
import { BLUR_DATA_URL_BASE64 } from '@shared-submodule/sm-constants'
import CustomLink from '@shared/components/customLink'
import MyImage from '@shared/components/myImage'

// type: 'featured' (image top + description), 'grid' (image top), 'list' (image left)
// image ratios as per Figma
const IMAGE_SIZE = {
  featured: { width: '874', height: '384' },
  grid: { width: '429', height: '241' },
  list: { width: '110', height: '92' }
}

function HomeArticleCard({ data, type = 'grid', isFirstImg }) {
  const slug = `/${data?.oSeo?.sSlug || '404'}`
  const publishDate = data?.dPublishDisplayDate || data?.dPublishDate

  return (
    <article id={data?._id} className={`${styles.card} ${styles[type]}`}>
      <CustomLink href={slug} prefetch={false}>
        <a className={`${styles.postImg} d-block`}>
          <MyImage
            priority={!!isFirstImg}
            src={getArticleImg(data)?.sUrl || noImage}
            alt={getArticleImg(data)?.sText || data?.sSrtTitle}
            placeholder="blur"
            blurDataURL={BLUR_DATA_URL_BASE64}
            height={IMAGE_SIZE[type].height}
            width={IMAGE_SIZE[type].width}
            layout="responsive"
            objectFit="cover"
            objectPosition="center top"
            sizes={type === 'list' ? '110px' : '(max-width: 767px) 100vw, (max-width: 1190px) 600px, 874px'}
          />
        </a>
      </CustomLink>
      <div className={`${styles.postDesc} d-flex flex-column`}>
        <h3 className={styles.title}>
          <CustomLink href={slug} prefetch={false}>
            <a>{data?.sSrtTitle || data?.sTitle}</a>
          </CustomLink>
        </h3>
        {type === 'featured' && data?.sDescription && <p className={styles.desc}>{data?.sDescription}</p>}
        {publishDate && <span className={styles.date}>{convertDt24h(dateCheck(publishDate))}</span>}
      </div>
    </article>
  )
}

HomeArticleCard.propTypes = {
  data: PropTypes.object,
  type: PropTypes.oneOf(['featured', 'grid', 'list']),
  isFirstImg: PropTypes.bool
}

export default HomeArticleCard
